import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/vehicle";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import { Suspense } from "react";
import { Controller } from "react-hook-form";

export default function RegisterVehicleView({
  goBack,
  onChangeSelect,
  goToLogin,
  isDisabled,
  types,
  brands,
  models,
  isLoading,
  error,
  errorPlate,
  errorCustomer,
  errorCreateUser,
  handlePlate,
  register,
  handleSubmit,
  errors,
  isVisibleModal,
  toggleModal,
  control,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Veículos"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div className="overflow-y-auto pb-4">
            <h2 className="mt-6 text-black text-xl font-semibold">Dados do veículo</h2>
            <div className="flex flex-col justify-center mt-1">
              <label className="text-sm text-gray-500 mt-3">Sua placa*</label>
              <InputMask 
                {...register("plate")}
                name="plate" 
                placeholder="Sua placa*" 
                className="uppercase mt-1 text-base font-semibold text-black w-full bg-transparent border border-gray-200 p-2 rounded-xl h-14 [&:not(:placeholder-shown)]:border-black" 
                mask="___-.@.." 
                replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }} 
                type="text"
              />
              {errors.plate && (
                <span className="text-red-500 text-xs">{errors.plate.message as string}</span>
              )}
              <label className="text-sm text-gray-500 mt-3">Tipo do veículo</label>
              <Controller 
                control={control}
                name="type"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Tipo do veículo" 
                    name="type" 
                    className="mt-1 text-base font-semibold text-black w-full bg-transparent border border-gray-200 p-2 rounded-xl h-14 [&:not([value='0'])]:border-black">
                      <option value="0">Tipo do veículo</option>
                      {types?.map((item, index) => (
                        <option key={index} value={item.id}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.type && (
                <span className="text-red-500 text-xs">{errors.type.message as string}</span>
              )}
              <label className="text-sm text-gray-500 mt-3">Marca</label>
              <Controller 
                control={control}
                name="brand"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Marca" 
                    name="brand" 
                    className="mt-1 text-base font-semibold text-black w-full bg-transparent border border-gray-200 p-2 rounded-xl h-14 [&:not([value='0'])]:border-black">
                      <option value="0">Marca</option>
                      {brands?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.brand && (
                <span className="text-red-500 text-xs">{errors.brand.message as string}</span>
              )}
              <label className="text-sm text-gray-500 mt-3">Modelo</label>
              <Controller 
                control={control}
                name="model"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Modelo" 
                    name="model" 
                    className="mt-1 text-base font-semibold text-black w-full bg-transparent border border-gray-200 p-2 rounded-xl h-14 [&:not([value='0'])]:border-black">
                      <option value="0">Modelo</option>
                      {models?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.model && (
                <span className="text-red-500 text-xs">{errors.model.message as string}</span>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-3 pb-2">
            <Button 
              className="rounded-xl bg-primary text-white"
              title="Continuar"
              type="submit"
              isDisabled={isDisabled}
            />
          </div>
        </form>
      </main>
      {error && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Houve um problema ao validar sua placa, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            toggleModal();
            handlePlate();
          }}
          actionSecondMessage="Não!"
          actionSecond={toggleModal}
        />
      </Suspense> }
      {errorPlate && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Atenção!"
          message="Esse veículo já possui um meio de pagamento automático cadastrado, não é possível adicionar ao Pedágio Eletrônico Sem Parar."
          actionMessage="Ok!"
          action={toggleModal}
        />
      </Suspense>}
      {errorCustomer && isVisibleModal && <Suspense fallback={null}>  
        <Modal
          title="Atenção!"
          message="Você já é nosso cliente."
          actionMessage="Login"
          action={() => {
            toggleModal();
            goToLogin();
          }}
        />
      </Suspense>}
      {errorCreateUser && isVisibleModal && <Suspense fallback={null}>  
        <Modal
          title="Ops!"
          message="Houve um problema, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            toggleModal();
            handleSubmit();
          }}
          actionSecondMessage="Não"
          actionSecond={toggleModal}
        />
      </Suspense>}
      {isLoading && <Suspense fallback={null}>
        <Loading/>
      </Suspense>}
    </div>
  );
}
